var video_cover_slider;
var video_action_active = false;

//* Featured area sliders */
$(".video-slider").each(function() {
    video_cover_slider = $(this);
    video_cover_slider.owlCarousel({
        loop: true,
        autoHeight: false,
        autoWidth: false,
        items: 1,
        margin: 0,
        nav: true,
        dots: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        center: false,
        fluidSpeed: 100,
        mouseDrag: false,
        autoplay: true,
        autoplayTimeout: 5124,
        autoplayHoverPause: true,
        onChanged: function(elem) {
            var current = this.$element.find('.owl-item.active');
            var format_content = current.find('.video-format-content');
            if (format_content !== undefined && format_content.children().length !== 0) {
                var item_wrap = current.find('.video-item');
                var cover = item_wrap.find('.video-cover');
                var cover_bg = current.find('.video-cover-bg');
                var cover_info = current.find('.video-cover-info');
                format_content.html('');
                format_content.fadeOut(300);
                //inplay.fadeOut(300);
                cover.fadeIn(300);
                cover_bg.removeAttr('style');
                cover_info.removeClass('video-playing');
            }
        },
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
    });

});

imagesLoaded.makeJQueryPlugin( $ );
$('.video-cover-bg:first').imagesLoaded(function() {
    $('.video-cover').animate({
        opacity: 1
    }, 300);
});

$("body").on('click', '.video-cover', function(e) {
    if( video_action_active ){
        return;
    }

    var action = $(this).attr('data-action');
    var container = $(this).closest('.video-cover-bg').find('.video-format-content');
    var item_wrap = $(this).closest('.video-item');
    var cover_bg = $(this).closest('.video-cover-bg');

    if (action == 'video') {
        video_action_active = true;

        if (item_wrap.parent().hasClass('owl-item')) {
            video_cover_slider.trigger('stop.owl.autoplay');
        }

        var data = {
            format: 'video',
            id: $(this).attr('data-id'),
            _token: $('meta[name="csrf-token"]').attr('content'),
        };

        var opener = $(this);

        opener.fadeOut(300, function() {
            container.append('<div class="video-format-loader"><div class="uil-ripple-css"><div></div><div></div></div></div>');
            container.fadeIn(300);

            $.post(routeArticleVideo, data, function(response) {
                container.find('.video-format-loader').remove();
                item_wrap.find('.video-cover-info').addClass('video-playing');
                container.append('<div class="video-popup-wrapper">' + response + '</div>');
                fitvids(container);                      
                $('body').addClass('video-in-play');

                setTimeout(function() {
                    if ($(window).width() > 768) {
                        var set_height = parseInt(container.find('.video-popup-wrapper').outerHeight());
                        cover_bg.animate({
                            height: set_height
                        }, 300);                        
                    } else {
                        cover_bg.css('height', 'auto');
                        cover_bg.parent().css('height', 'auto');                            
                    }
                }, 50);
                video_action_active = false;
            });
        });
    }
});

//* Cinema mode */

var video_before_cinema_height;
var video_before_cinema_width;

$("body").on('click', '.action-icon', function(e) {
    e.preventDefault();
                
    var current_video = $(this).closest('.video-item').find('.video-format-content');

    if(!current_video.children().length) $(this).closest('.video-item').find('.video-cover').trigger('click');

    $(window).scrollTop(0);

    $('body').addClass('video-popup-on');
    current_video.addClass('video-popup');

    $('.video-slider .owl-nav, nav.sticky-top').css('display','none');
    $('.video-slider.owl-carousel .owl-item:not(.active)').css('opacity',0);

    if ($('.video-slider').length) {
        video_before_cinema_height = current_video.height();
        video_before_cinema_width = current_video.width();

        if ($(window).width() > 990) {
            current_video.height($(window).height()).width($(window).width()).css('top',0);//.css('top', -$('nav.sticky-top').outerHeight());//.css('left',-$(window).width() / 4);
        } else {
            current_video.height($(window).height()).width($(window).width()).css('top', 0);//.css('left',-$(window).width() / 4);
            $('.owl-carousel').addClass('disable-owl-swipe');
            $('body').on('touchmove', '.disable-owl-swipe', function(e) { e.stopPropagation(); });
        }

        var current_slide = $('.video-popup').parent().parent().parent();
        current_slide.attr('data-width', current_slide.width()).height($(window).height()).width($(window).width());
    }

    current_video.append('<a class="video-popup-close" href="javascript:void(0);"><i class="fa fa-times"></i></a>');

    
});

function popup_image(obj) {

    if (obj.find(".wp-block-image a").length) {

        var popupImg = obj.find(".wp-block-image a");

        popupImg.find('img').each(function() {
            var $that = $(this);
            if ($that.hasClass('alignright')) {
                $that.removeClass('alignright').parent().addClass('alignright');
            }
            if ($that.hasClass('alignleft')) {
                $that.removeClass('alignleft').parent().addClass('alignleft');
            }
        });

        popupImg.magnificPopup({
            type: 'image',
            tClose: 'Fermer (Esc)',
            tLoading: 'Chargement...',
            gallery: {
                enabled: true,
                tPrev: 'Précédent (Touche flèche gauche)',
		        tNext: 'Suivant (Touche flèche droite)',
		        tCounter: '%curr% de %total%',
            },
            image: {
                titleSrc: function(item) {
                    return item.el.closest('figure').find('figcaption').text();
                }
            },
            removalDelay: 300,
            mainClass: 'mfp-with-fade',
            closeBtnInside: false,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><i class="fv fv-close"></i></button>',
            callbacks: {
                open: function() {
                    $.magnificPopup.instance.next = function() {
                        var self = this;
                        self.wrap.removeClass('mfp-image-loaded');
                        setTimeout(function() {
                            $.magnificPopup.proto.next.call(self);
                        }, 120);
                    };
                    $.magnificPopup.instance.prev = function() {
                        var self = this;
                        self.wrap.removeClass('mfp-image-loaded');
                        setTimeout(function() {
                            $.magnificPopup.proto.prev.call(self);
                        }, 120);
                    };
                },
                imageLoadComplete: function() {
                    var self = this;
                    setTimeout(function() {
                        self.wrap.addClass('mfp-image-loaded');
                    }, 16);
                }
            }
        });
    }

}

popup_image($('article.article-full'));

//* Close popup */
$("body").on('click', '.video-popup-close', function(e) {

    var cover_bg = $(this).closest('.video-cover-bg');

    if ($('.video-slider').length) {

        $(this).closest('.video-format-content').removeAttr('style');
        var current_slide = $('.video-popup').parent().parent().parent();
        current_slide.removeAttr('style').css('width', current_slide.attr('data-width'));
    }

    $(this).closest('.video-format-content').removeClass('video-popup');
    $('.video-slider .owl-nav, nav.sticky-top').css('display','block');
    $('.video-slider.owl-carousel .owl-item:not(.active)').css('opacity',1);
    $('body').removeClass('video-popup-on');
    $(this).remove();
    $('.disable-owl-swipe').off('touchmove');
    $('.owl-carousel').removeClass('disable-owl-swipe');

});

//* Close popup on Escape */
$(document).keyup(function(ev) {
    if (ev.keyCode == 27 && $('body').hasClass('video-popup-on')) {
        $('.video-popup-close').click();
    }
});

//* Top Serie Slider */
$('.parcours-slider').owlCarousel({
    loop: true,
    autoHeight: false,
    autoWidth: false,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
        },
        600:{
            items:2,
        },
        900:{
            items:3,
        }                    
    },
    margin: 20,
    dots: false,
    nav:true,
    center: false,
    fluidSpeed: 100,
    mouseDrag: true,
    touchDrag: true,
    autoplay: true,
    autoplayTimeout: 4358,
    autoplayHoverPause: true,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
});

//* List Serie Slider */
$('.series-slider').owlCarousel({
    loop: true,
    autoHeight: false,
    autoWidth: false,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
        },
        600:{
            items:2,
        },
        900:{
            items:3,
        }                    
    },
    margin: 20,
    dots: false,
    nav:true,
    center: false,
    fluidSpeed: 100,
    mouseDrag: true,
    touchDrag: true,
    autoplay: true,
    autoplayTimeout: 4250,
    autoplayHoverPause: true,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
});

$('#articlesMore').on('click', function(){
    var $this = $(this);
    $this.button('loading').attr('disabled',true);
    $.ajax({
        url: routeArticleLast,
        method: 'GET',
        data: {'offset':$('#articles-more').find('.article-item').length + article_offset, 'limit':article_nb, 'category': current_category, 'current': current_article, 'maxcols' : (typeof maxcols !== 'undefined') ? maxcols:4},
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
    }).done(function(response){
        if(response){
            $('#articles-more').append(response);
        }
    }).always(function(){
        $this.button('reset').removeAttr('disabled');
        if($('#articles-more').find('.article-item').length + article_offset >= $('#articles-more').attr('data-length')) $this.hide();
    });
});

$('#frm_article_subscription').on('submit', function(e){
    $("#subscriptionForm").find('div[role=alert]').remove();
    var $this = $(this);
    if($(this).valid()){    
        $this.find('button[type=submit]').button('loading').attr('disabled',true);
        $.ajax({
            url:routeArticleSubscription,
            method:"POST",
            data: $('#frm_article_subscription').serialize(),
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        }).done(function(response){
            if(response){
                if(response.type == "success"){
                    $("#subscriptionForm").prepend("<div class='alert alert-success align-items-center p-1 d-flex' style='display:none' role='alert'><span class='fa-solid fa-circle-check me-2'></span><div>"+response.message+"</div></div>");
                    $("#subscriptionForm").find('div[role=alert]').fadeIn().delay(5000).fadeOut(500, function(){
                        $(this).remove();
                    });
                    $('#frm_article_subscription')[0].reset();
                }else{
                    $("#subscriptionForm").prepend("<div class='alert alert-danger d-flex align-items-center p-1' role='alert'><span class='fa-solid fa-triangle-exclamation me-2'></span><div>"+response.message+"</div></div>");
                }
            }
        }).fail(function(){
            $("#subscriptionForm").prepend("<div class='alert alert-danger d-flex align-items-center p-1' role='alert'><span class='fa-solid fa-triangle-exclamation me-2'></span><div>Erreur lors de l'envoi, merci de recommencer</div></div>");
        }).always(function(){
            $this.find('button[type=submit]').button('reset').removeAttr('disabled');
        });
    }
    e.stopPropagation();
    return false;
});

//*  Scroll position on article */
function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left >= 0 &&
        rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

document.addEventListener('scroll', function () {
    const article = document.querySelector('.article-full');
    if(isInViewport(article)){
        $('#serie-nav').show();
    }else{
        $('#serie-nav').hide();
    }

}, {
    passive: true
});

/** Cours Slider */
$('#cours-last-slider').owlCarousel({
    loop: true,
    autoHeight: false,
    autoWidth: false,
    margin: 20,
    nav: true,
    dots: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    center: true,
    fluidSpeed: 100,
    mouseDrag: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    lazyLoad: true,
    navText: ['<i class="fa fa-angles-left"></i>', '<i class="fa fa-angles-right"></i>'],
    responsive : {
        // breakpoint from 0 up
        0: {
            items: 2,
            nav: false,
            center:false,
        },
        540 : {
            items: 2,
            nav: false,
            center:false,
        },
        // breakpoint from 480 up
        1000 : {
            items: 3,
            nav: true,
        }
    }
});

/** Formation Slider */
$('.formations-slider').owlCarousel({
    loop: true,
    autoHeight: false,
    autoWidth: false,
    margin: 20,
    nav: true,
    dots: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    center: false,
    fluidSpeed: 100,
    mouseDrag: true,
    autoplay: true,
    autoplayTimeout: Math.random() * 1000 + 5000,
    autoplayHoverPause: true,
    lazyLoad: true,
    navText: ['<i class="fa fa-angles-left"></i>', '<i class="fa fa-angles-right"></i>'],
    responsive : {
        // breakpoint from 0 up
        0: {
            items: 2,
            nav: false,
            center:false,
        },
        720 : {
            items: 3,
            nav: false,
            center:false,
        },
        // breakpoint from 480 up
        1000 : {
            items: 4,
            nav: true,
        }
    }
});
